var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uiLoader-Box"},[_c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"loader"}),_c('div',{staticClass:"loader-text"},[_vm._v("\n      .. loading ..\n    ")])])])
}]

export { render, staticRenderFns }